import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
import { useMandatesMobile } from "./mandatesMobile/useMandatesMobile";
import { MandatesMobileListItem } from "./mandatesMobile/mandatesMobileListItem";
import { translate } from "@/config/translator";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";

export default function MandatesMobile() {
  const {
    onSelectMandate,
    isTablet,
    navigate,
    selectedMandateId,
    user,
    lang,
    allMandates,
    mandateSearchQuery,
    setMandateSearchQuery,
  } = useMandatesMobile();

  if (isTablet) return <></>;
  return (
    <>
      <TopBarMobile header="mandates" onBack={() => navigate(-1)} />
      <div className="w-full py-6 flex flex-col gap-4 divide-y divide-neutral">
        {user?.mandateRights.map(({ mandate }) => (
          <MandatesMobileListItem
            mandate={mandate}
            isSelected={mandate.id === selectedMandateId}
            onSelect={() => onSelectMandate(mandate)}
          />
        ))}
      </div>

      {(user?.scopes.includes("admin") ||
        user?.scopes.includes("employee")) && (
        <>
          <div className="font-medium text-lg p-6">
            {translate("allMandates", lang)}
          </div>
          <div className="px-6 pb-6">
            <PspTextInput
              contentBefore={
                <FontAwesomeIcon
                  icon={faSearch}
                  className="text-font-secondary text-lg"
                />
              }
              value={mandateSearchQuery}
              onChange={setMandateSearchQuery}
              label="search"
            />
          </div>
          <div className="w-full flex flex-col divide-y divide-neutral">
            {allMandates?.map((mandate) => (
              <MandatesMobileListItem
                mandate={mandate}
                isSelected={mandate.id === selectedMandateId}
                onSelect={() => onSelectMandate(mandate)}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
}
